let Auth = function ($q, $state) {
  "ngInject";

  let service = this;

  service.responseError = function(response) {
    if (response.status == 401){
      // window.location = "/login";
      $state.go("login");
    }
    return $q.reject(response);
  };

}
export default Auth;



// WEBPACK FOOTER //
// ./client/app/services/authService/auth.service.js